import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { MedicalExpensesStyled } from '../../../asset/styled/deductions/MedicalExpensesStyled';

import titleImg from '../../../asset/img/medical_title_img.svg';

import InfoBanner from '../../../components/Banner';
import SubTitleSection from '../../../components/SubTitleSection';
import MedicalItemSection from './MedicalItemSection';
import TotalSection from '../../../components/TotalSection';
import { getMedicalInfo, resetMedicalState, setDetailReload } from './medicalSlice';
import MedicalDetail from './detail';
import { formatNumber } from '../../../common/Util';

const MedicalExpenses = () => {
  const { t } = useTranslation('deductions/medicalExpenses');
  const dispatch = useDispatch();
  const { dataList, isRender, reload, total, salary } = useSelector(state => state.medical);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    dispatch(getMedicalInfo());
  }, []);

  useEffect(() => {
    if (reload != -1) {
      dispatch(getMedicalInfo());
    }
  }, [reload]);

  //언마운트시 초기화
  useEffect(() => {
    return () => {
      dispatch(resetMedicalState());
    };
  }, [dispatch]);

  const onOpen = () => {
    dispatch(setDetailReload(-1));
    setIsOpen(true);
  };
  const onClose = () => {
    setIsOpen(false);
  };
  return (
    <MedicalExpensesStyled>
      <InfoBanner
        title={t('bannerSection.title')}
        description={`${t('bannerSection.description1')}(${formatNumber(
          parseInt(Number(salary) * 0.03),
        )}${t('bannerSection.description2')}`}
      />
      <SubTitleSection title={t('title')} img={titleImg} />
      <MedicalItemSection onOpen={onOpen} />
      <TotalSection total={total} />
      {/* 상세 */}
      <MedicalDetail isOpen={isOpen} onClose={onClose} />
    </MedicalExpensesStyled>
  );
};

export default MedicalExpenses;
